import { render, staticRenderFns } from "./handbook.vue?vue&type=template&id=23ac88b0&scoped=true&"
import script from "./handbook.vue?vue&type=script&lang=js&"
export * from "./handbook.vue?vue&type=script&lang=js&"
import style0 from "./handbook.vue?vue&type=style&index=0&id=23ac88b0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac88b0",
  null
  
)

export default component.exports